module.exports = __webpack_public_path__ + "assets/img/home-product-advantage-light-en.2294076e.png";